import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../static/css/Header.css";
import dropdown from "../../static/images/dropdown.svg";
import profile from "../../static/images/Profile.png";
import Pluseicon_dashboard from "../../static/svg/Pluseicon_dashboard";
import Dashboardicon from "../../static/svg/Dashboardicon";
import CreateCrew from "../../static/svg/CreateCrew";
import Agents from "../../static/svg/Agents";
import Space from "../../static/svg/Space";
import InfanionLogo from "../../static/svg/InfanionLogo";
import Thecore from "../../static/svg/Thecore";
import UserProfile from "../../static/images/user.svg"
import LogoutIcon from "../../static/svg/LogoutIcon";
import AccessControl from "../molecules/AccessControl";
import DynamicLogo from "./DynamicLogo";
// The Header component provides a top navigation bar with options for accessing different sections,
//  logging out, and managing modals for creating entities like crews, agents, and spaces.

const Header: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("user_account");
    localStorage.removeItem("access_token");
    navigate("/login");
  };
  const navigate = useNavigate();

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleClick = (data: string) => {
    if (data === "crew") {
      navigate("/add_crew");
      setShowModal(false);
    } else if (data === "agent") {
      navigate("/add_agent/0");
      setShowModal(false);
    } else if (data === "space") {
      navigate("/add_space");
      setShowModal(false);
    } else if (data === "training") {
      navigate("/training/0/upload");
      setShowModal(false);
    }
  };

  return (
    <>
      {/* Navbar */}
      <div className="headerWrapper p-0">
        <div className="row m-0">
          <div className="col-12 p-0">
            <nav className="navbar navbar-expand-lg header-navbar  d-flex justify-content-between ps-2 pe-2">
              <div className="container-fluid">
                {/* Brand Logo */}
                <Link
                  to="/"
                  className="navbar-brand d-flex align-items-center ms-1"
                >
                  {/* <InfanionLogo /> */}
                  <DynamicLogo/>
                </Link>

                <div
                  className="ms-auto d-flex justify-content-between align-items-center "
                  style={{ cursor: "pointer" }}
                >
                   <AccessControl
                        requiredPermissions={[
                          {
                            permission:'Knowledge_core',
                            types: ["read"],
                          },
                        ]}
                        renderNoAccess={<></>}
                      >
                  <div className="me-3">
                    <Link to={"/core"}>
                      <Thecore />
                    </Link>
                  </div>
                  </AccessControl>
                  

                  <div
                    onClick={handleOpenModal}
                    className="me-3 add-crew-icon"
                    title="Create"
                    data-bs-toggle="tooltip"
                    style={{ cursor: "pointer" }}
                  >
                    <Pluseicon_dashboard />
                  </div>
                  <div  onClick={() => navigate("/")} className="menubox">
                    <Dashboardicon />
                  </div>
{/* 
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/")}
                    className="dashboard ms-3"
                  >
                    <div style={{ color: "lightblue" }}>Dashboard</div>
                  </div> */}
                  <div className="profile ms-4">
                    <img src={UserProfile} alt="profile" />
                  </div>

                  {/* <div className="dropdown ms-3">
                    <img src={dropdown} alt="dropdown" className="icon me-1" style={{ width: '20px' }} />
                  </div> */}
                  <div className="dropdown ms-2 position-relative">
                    <img
                      src={dropdown}
                      alt="dropdown"
                      className="icon me-1"
                      style={{ width: "20px", cursor: "pointer" }}
                      onClick={() => setShowDropdown(!showDropdown)}
                    />

                    {showDropdown && (
                      <div className="dropdown-menu show position-absolute end-0 mt-2">
                        <div className="dropdown-arrow"></div>{" "}
                        {/* Manually added arrow */}
                        <button
                          className="dropdown-item text-danger"
                          onClick={handleLogout}
                        >
                          <div className="d-flex align-items-center">
                            <span className="me-2">
                              <LogoutIcon />
                            </span>
                            <div className="text-blue">Logout</div>
                          </div>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>

      {showModal && (
        <>
          {/* Overlay */}
          <div
            className="modal-overlay"
            onClick={handleCloseModal} // Optional: close the modal when clicking outside
          ></div>

          {/* Modal */}
          <div
            className="modal show d-block"
            id="exampleModalCenter"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content p-4">
                <div className="modal-header border-0">
                  <h5 className="modal-title" id="exampleModalLongTitle">
                    Create{" "}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleCloseModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="Header_popup_design">
                    <div
                      onClick={() => handleClick("crew")}
                      className="popup_card cursor-pointer"
                    >
                      <div className="mb-2">
                        <CreateCrew />
                      </div>
                      <div className="card-title">Crew</div>
                    </div>

                  
                    <div
                      onClick={() => handleClick("agent")}
                      className="popup_card cursor-pointer"
                    >
                      <div className="mb-2">
                        <Agents />
                      </div>
                      <div className="card-title">Agents</div>
                    </div>
                    <div
                      onClick={() => handleClick("space")}
                      className="popup_card cursor-pointer"
                    >
                      <div className="mb-2">
                        <Space />
                      </div>
                      <div className="card-title">Knowledge hub </div>
                    </div>
                    <div
                      onClick={() => handleClick("")}
                      className="popup_card cursor-pointer"
                    >
                      <div className="mb-2">
                        <CreateCrew />
                      </div>
                      <div className="card-title">Prompting</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;
